export default {
      id: "ic_demarches-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_demarches-usage",
      toString: function () {
        return this.url;
      }
    }